export type ValidationErrorField = { field: string; error: string };
export type ErrorPayload = {
  errorCode: string;
  errorMessage: string;
  timestamp: number;
  uri: string;
  validationErrors?: ValidationErrorField[];
};

export type RedirectErrorData = {
  origin: string;
  pathname: string;
  search: string;
  fullPath: string;
  reload: boolean;
};

export type RequestError = {
  status: number;
  text: string;
  data: ErrorPayload | string;
  originalStatus?: number;
  code: number;
  blocking: boolean;
  redirectError?: RedirectErrorData;
};

export const isErrorWithStatus = (
  errorData: unknown,
): errorData is RequestError => {
  if (errorData && typeof errorData === "object" && "status" in errorData) {
    return true;
  }
  return false;
};

export const isRequestError = (
  errorData: unknown,
): errorData is RequestError => {
  if (
    errorData &&
    typeof errorData === "object" &&
    "status" in errorData &&
    "text" in errorData &&
    "data" in errorData
  ) {
    return true;
  }
  return false;
};

export const isErrorPayload = (
  errorPayload: unknown,
): errorPayload is ErrorPayload => {
  if (
    errorPayload &&
    typeof errorPayload === "object" &&
    "errorCode" in errorPayload &&
    "timestamp" in errorPayload
  ) {
    return true;
  }
  return false;
};
